export default __webpack_public_path__ + "f1e8894ff61a3fd4b252abc443cd6885.png";